import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotifierService } from 'src/app/_services/notifier.service';
@Component({
  selector: 'app-view-ports',
  templateUrl: './view-ports.component.html',
  styleUrls: ['./view-ports.component.css']
})
export class ViewPortsComponent implements OnInit {

  @Output() hideModal = new EventEmitter<any>();
  @Input() PortList :any=[]

  constructor(public notifier: NotifierService) { }

  ngOnInit(): void {
    this.notifier.disableScroll();
  }
  no(){
    this.hideModal.emit({ status: 0 });
  }

  ngOnDestroy(): void {
    this.notifier.enableScroll();
}
}
